<template>
  <div class="gray-back" style="height: 100%">
      窗口{{windowIndex + 1}}/{{windowCount}} {{last_count}}/{{total}}
      <!-- {{list}} -->
  </div>
</template>
<style scoped> 
</style>
<script>
import Vue from 'vue';

import {
  Cell,
  Field,
  Tag,
  CellGroup,
  Stepper,
  Toast,
  Button,
    Switch,
  NumberKeyboard
} from 'vant';

export default {
  name: 'CommonLogin',
  components: { 
  },
  data: function () {
    return { 
      list:[],
      total:0,
      last_count:0,
      index:0,
      windowCount:1,
      windowIndex:0,
    }
  },
  filters: {},
  mounted() {
    let that = this;
    // that.formData.id = that.$route.query.id
    // this.fetch();
    
    document.title="队伍证书上云"
    that.getList() 
    setTimeout(() =>{
      window.location.reload()
    },300000)
  },
  watch: { 
  },
  destroyed() {
  },
  methods: {

    upCert(){
      let that =this
      if(!that.list.length || that.index >= that.list.length){
        return
      }
      sessionStorage.setItem(that.progressKey('index'), String(that.index))
      sessionStorage.setItem(that.progressKey('total'), String(that.list.length))
      that.$api.get(that.list[that.index], {}, (res) => {
        console.log('upCert res',res)
        that.index ++
        that.last_count = that.index
        that.upCert()
      }, (res) => {
        console.log('接口报错', that.list[that.index], res)
        that.index ++
        that.last_count = that.index
        that.upCert()
      })

    },
    getList() {
      let that = this;
      that.$api.post('/api/Dshequscore/getCerList', {}, (res) => { 
        console.log('getList res',res)
        let all = res.data || []
        let count = parseInt(that.$route.query.n || '1', 10)
        let current = parseInt(that.$route.query.i || '0', 10)
        if(!count || count < 1){
          count = 1
        }
        if(current < 0 || current >= count){
          current = 0
        }
        that.windowCount = count
        that.windowIndex = current
        let size = Math.ceil(all.length / count)
        that.list = all.slice(current * size, (current + 1) * size)
        that.total = that.list.length
        let savedTotal = parseInt(sessionStorage.getItem(that.progressKey('total')) || '0', 10)
        let savedIndex = parseInt(sessionStorage.getItem(that.progressKey('index')) || '0', 10)
        if(savedTotal === that.total && savedIndex > 0 && savedIndex < that.total){
          that.index = savedIndex
        }else{
          that.index = 0
        }
        that.last_count = that.index
        that.upCert()
      }, (res) => { 
      })
    },
    progressKey(name){
      return 'score_up_oss_' + this.windowCount + '_' + this.windowIndex + '_' + name
    },

 
  }
}
</script>



// WEBPACK FOOTER //
// ScoreUpOss.vue?3da5e311